<template>
  <div class="app-mail-complex_amc" :class="{ [curTheme]: true }">

    <input-title :required="options.required" :description="options.description"/>

    <div class="input-groups">

      <div
        v-for="(_, i) in valueLocal"
        :key="`mail-group-${i}`"
        class="input-group"
        @click="removeErrorLocal(i)">

        <div class="aml_block-wrap">

          <div class="aml_block aml_block--mail">
            <el-autocomplete
              :ref="`input${i}`"
              clearable
              :class="{ 'child-has-error': error[i].mail }"
              v-model="valueLocal[i].mail"
              :trigger-on-focus="false"
              @select="onSelect"
              @input="onInput"
              :fetch-suggestions="fetchSuggestions"
              class="amc_input"/>
          </div>

          <div
            v-if="error[i].mail"
            class="ait_message ait_message--error">
            {{ error[i].mail }}
          </div>

          <div
            v-if="checkVerifyOn()"
            class="amс_approve_ama">
            <el-button
              @click="sendVerificationCode(i)"
              :class="{ 'not-active': btnSendInactiveTimer }"
              class="vivid-button ama_btn">
              Выслать проверочный код *</el-button>
            <el-input
              class="ama_code"
              :class="{ 'child-has-error': error[i].code }"
              @focus="error[i].code = ''"
              v-model="valueLocal[i].code"
              placeholder="Введите полученный код"/>
            <el-tooltip
              class="ama_help"
              placement="top"
              :enterable="false"
              :open-delay="300">
              <div slot="content">После нажатия кнопки «Выслать проверочный код»
                на ваш e-mail будет выслано письмо с кодом, который нужно
                ввести в данное поле.
              </div>
              <i class="el-icon-question"></i>
            </el-tooltip>
          </div>

          <div
            v-if="error[i].code"
            class="ait_message ait_message--error">
            {{ error[i].code }}
          </div>

          <div class="amc_info">
            <i class="amc_info-icon el-icon-warning"></i>
            Можете использовать любой почтовый домен. Однако, чтобы получить
            возможность депонировать объекты, Вам нужно использовать
            почтовый домен организации-партнера проекта.
            <button class="amc_info-btn" @click="domainWinOn = true">ВЫБРАТЬ ДОМЕН ПАРТНЕРА</button>
          </div>

        </div>

      </div>

    </div>

    <add-rem-btns/>

    <el-dialog
      title="Выберите почтовый домен"
      :visible.sync="domainWinOn">
      <div class="amc_win-filter">
        <el-input
          v-model="domainFilterQuery"
          placeholder="Поиск домена..."
          clearable></el-input>
      </div>
      <div class="amc_win-items">

        <template
          v-for="(org, i) in orgsFiltered">
          <div
            v-if="org.MailDomains.length > 0"
            class="amc_win-item"
            :key="`org-${i}`">
            <div class="amc_win-title">{{ org.ShortName }}:</div>
            <template
              v-for="(domain, j) in org.MailDomains">
              <button
                :key="`domain-${i}-${j}`"
                class="amc_win-btn"
                @click="setDomain(domain)">
                {{ domain }}</button><template
                  v-if="(j+1) < org.MailDomains.length">,
                  </template>
            </template>
          </div>
        </template>

      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="dialog-primary-btn"
          @click="domainWinOn = false">
          Закрыть</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import axios from 'axios';
import approve from 'approvejs';
import Common from './mixins/Common';

export default {

  mixins: [Common],

  data() {
    return {
      valueBase: { mail: '', code: '' },
      errorBase: { mail: '', code: '' },
      domainWinOn: false,
      domainFilterQuery: '',
      mailSource: null,
      btnSendInactiveTimer: null,
      mailCheckInProgress: false,
    };
  },

  created() {
    // Add error messages
    this.validateMessages = Object.assign(
      this.validateMessages, {
        mail: 'Введите корректный адрес электронной почты!',
        busy: 'Этот адрес электронной почты уже занят!',
        code: 'Введите код подтверждения!',
      },
    );
  },

  computed: {

    domains() {
      const orgs = this.$store.getters['orgs/getOrgs'];
      const domains = [];
      orgs.forEach((org) => {
        org.MailDomains.forEach((domain) => {
          domains.push({ value: domain });
        });
      });
      return domains;
    },

    orgs() {
      return this.$store.getters['orgs/getOrgs'];
    },

    orgsFiltered() {
      const query = this.domainFilterQuery.toLowerCase();
      if (query.length === 0) {
        return this.orgs;
      }
      const orgsResult = [];
      // Filter by mail domains
      for (let i = 0; i < this.orgs.length; i += 1) {
        const mailDomains = this.orgs[i].MailDomains;
        const mailDomainsFound = [];
        for (let j = 0; j < mailDomains.length; j += 1) {
          if (mailDomains[j].toLowerCase().indexOf(query) > -1) {
            mailDomainsFound.push(mailDomains[j]);
          }
        }
        if (mailDomainsFound.length > 0) {
          orgsResult.push({
            ShortName: this.orgs[i].ShortName,
            MailDomains: mailDomainsFound,
          });
        }
      }
      // Filter by organizations
      if (orgsResult.length === 0) {
        for (let i = 0; i < this.orgs.length; i += 1) {
          if (this.orgs[i].ShortName.toLowerCase().indexOf(query) > -1) {
            orgsResult.push(this.orgs[i]);
          }
        }
      }
      return orgsResult;
    },

  },

  methods: {

    removeErrorLocal(i) {
      if (this.error[i].mail !== this.validateMessages.busy) {
        this.removeError(i);
      }
    },

    sendVerificationCode(i) {
      const value = this.getValue();
      const mail = Array.isArray(value) ? value[i] : value.mail;
      const btn = this.$el.querySelector('.ama_btn');
      btn.setAttribute('disabled', 'true');
      axios.get(`users/verify-mail/${mail}`).then((r) => {
        btn.removeAttribute('disabled');
        this.$message.closeAll();
        this.$message.success(r.data);
        this.btnSendInactiveTimer = setTimeout(() => {
          this.btnSendInactiveTimer = null;
        }, 5 * 60 * 1000);
      }).catch((e) => {
        btn.removeAttribute('disabled');
        this.$message.closeAll();
        const r = e.response;
        if (r.status === 403) {
          this.$message.error(r.data.message);
          this.btnSendInactive = true;
          if (this.btnSendInactiveTimer === null) {
            this.btnSendInactiveTimer = setTimeout(() => {
              this.btnSendInactiveTimer = null;
            }, r.data.time * 1000);
          }
        } else {
          this.$message.error(e.response.data);
        }
      });
    },

    checkVerifyOn() {
      const isEqualToSource = this.mailSource
        && this.mailSource[0] === this.valueLocal[0].mail;
      return this.options.verify
        && this.valueLocal[0].mail.length > 0
        && !this.error[0].mail
        && !this.mailCheckInProgress
        && approve.value(this.valueLocal[0].mail, { email: true }).approved
        && !isEqualToSource;
    },

    checkMailBusy() {
      this.mailCheckInProgress = true;
      clearTimeout(this.btnSendInactiveTimer);
      this.btnSendInactiveTimer = null;

      // Prevent check if unique validator not set to true
      if (!this.options.unique
        || (this.mailSource && this.mailSource[0] === this.valueLocal[0].mail)
      ) return;

      const mail = this.valueLocal[0].mail;

      if (this.options.verify && this.mailSource && mail === this.mailSource) {
        this.removeError(0);
        return;
      }

      const result = approve.value(mail, { email: true });
      if (result.approved) {
        axios.get('users/exist', { params: { mail } }).then((resp) => {
          if (resp.data) {
            this.error[0].mail = this.validateMessages.busy;
            this.$forceUpdate();
          } else {
            this.removeError(0);
          }
          this.mailCheckInProgress = false;
        });
      }
    },

    setValue(value) {
      this.valueLocal[0].mail = value[0];
      this.mailSource = value;
    },

    onInput() {
      this.checkMailBusy();
      this.checkVerifyOn();
    },

    setDomain(domain) {
      this.$refs.input0[0].focus();
      this.domainWinOn = false;
      let domainArr = [''];
      if (this.valueLocal[0]) {
        domainArr = this.valueLocal[0].mail.split('@');
      }
      this.valueLocal[0].mail = `${domainArr[0]}@${domain.trim()}`;
      this.checkMailBusy();
      this.checkVerifyOn();
    },

    onSelect() {
      window.AppMailAuthJustSelected = true;
    },

    fetchSuggestions(query, cb) {
      const [namePt, domainPt] = query.split('@');
      if (domainPt && domainPt.length > 0) {
        const domainsFiltered = this.domains
          .filter(domain => domain.value.indexOf(domainPt) === 0)
          .map(domain => ({ value: `${namePt}@${domain.value}` }));
        if (domainsFiltered.length > 1 || (domainsFiltered.length === 1
          && domainsFiltered[0].value.split('@')[1].length > domainPt.length)
        ) {
          cb(domainsFiltered);
          return;
        }
      }
      cb([]);
    },

    getError() {
      // Validate required
      if (this.options.required) {
        this.valueLocal.forEach((value, i) => {
          const result = approve.value(value.mail, { required: true });
          this.error[i].mail = result.approved ? '' : this.validateMessages.required;
        });
      }
      // Validate email
      this.valueLocal.forEach((value, i) => {
        if (this.error[i].mail) return;
        const result = approve.value(value.mail, { email: true });
        this.error[i].mail = result.approved ? '' : this.validateMessages.mail;
      });
      // Validate verify code required
      let isNewMail = true;
      if (this.mailSource && this.mailSource[0] !== this.valueLocal[0].mail) {
        isNewMail = false;
      }
      if (this.options.verify && isNewMail) {
        this.valueLocal.forEach((value, i) => {
          if (!this.checkVerifyOn() || this.error[i].mail) {
            return;
          }
          this.error[i].code = value.code === '' ? this.validateMessages.code : '';
        });
      }
      this.$forceUpdate();
      return this.error;
    },

  },

};
</script>

<style lang="scss">
@import '../../../styles/common/main';

.app-mail-complex_amc {
  .amc_input {
    width: 100%;
    .el-input__inner {
      &::selection {
        background: rgba(255, 255, 255, .6);
        color: #000;
      }
    }
  }
  .amc_info {
    margin: 20px 0 40px;
    padding: 15px 20px 20px 40px;
    font-size: 15px;
    line-height: 19px;
    font-weight: 300;
    @include border-radius(10px);
    background: rgba(255, 255, 255, .1);
    color: #fff;
    position: relative;
    @media (max-width: 500px) {
      font-size: 14px;
    }
  }
  .amc_info-icon {
    margin-right: 5px;
    position: absolute;
    left: 15px;
    top: 15px;
  }
  .amc_info-btn {
    color: #fff;
    @include border-radius;
    cursor: pointer;
    padding: 2px 12px 0;
    font-weight: 300;
    font-size: 11px;
    display: inline-block;
    border: 1px solid $color-1;
    @include transition;
    background: $color-1;
    white-space: nowrap;
    position: absolute;
    bottom: -9px;
    left: 50%;
    @include transform(translateX(-50%));
    &:hover {
      background: #8e5a97;
    }
  }
  .amc_win-items {
    .amc_win-item {
      margin: 10px 0;
      padding: 10px 15px 7px;
      border: 1px solid #efefef;
      background: #f9f9f9;
      @include border-radius(19px);
    }
  }
  .amc_win-title {
    font-weight: 600;
    margin-right: 5px;
    font-size: 16px;
    color: #000;
    display: inline-block;
  }
  .amc_win-btn {
    display: inline-block;
    font-size: 15px;
    cursor: pointer;
    &:hover {
      color: $color-1;
    }
  }
  .amс_approve_ama {
    text-align: center;
    padding: 20px 0 0;
    .ama_btn {
      height: 40px;
      padding: 2px 0 0;
      width: 250px;
      white-space: normal;
      line-height: 0;
      display: block;
      margin: 0 auto 10px;
      transition: opacity .3s;
      &:focus,
      &:hover {
        color: #fff;
      }
      &.not-active {
        opacity: .3;
      }
    }
    .ama_code {
      width: 220px;
    }
    .ama_help {
      margin-left: 5px;
      color: #fff;
    }
  }
  .el-dialog {
    max-width: 700px;
    .el-input__inner {
      background: #fff;
      @include box-shadow(none);
      border: 1px solid #ccc;
      color: #000;
      &::selection {
        background: rgba(0, 0, 0, .6);
        color: #fff;
      }
    }
    :-ms-input-placeholder {
      color: #333 !important;
    }
    :-ms-input-placeholder {
      color: #333 !important;
    }
    ::placeholder {
      color: #333 !important
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/inputs/widgets/AppMailComplex.vue